import { Component, OnInit, Input } from '@angular/core';
import * as moment from "moment";

@Component({
  selector: 'usb-item-insurance',
  templateUrl: './item-insurance.component.html',
  styleUrls: ['./item-insurance.component.scss']
})
export class ItemInsuranceComponent implements OnInit {

  @Input() item: any;
  @Input() currencies: any;
  @Input() currencyAgency: any;
  @Input() styleSidebar: any;

  constructor() { }

  ngOnInit() {
    console.log('item', this.item);
  }

  // Pasar primer letra de cada palabra a mayuscula en una cadena
  stingUpperCase(str){
    let e = str.toLowerCase()
    return e.replace(/\b\w/g, l => l.toUpperCase())
  }

    formatDate(date: string): string {
    if (!date) return '';
    return moment(date).format('ddd DD MMM YYYY');
  }
}
